var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "button-loader",
        { attrs: { loading: _vm.loading, "show-custom-color": "" } },
        [
          _c(
            "b-dropdown",
            {
              attrs: {
                id: "response-information-action-buttons",
                variant: "transparent",
                "toggle-class": "text-gray position-static bs-0",
                "no-caret": "",
                dropup: "",
                right: "",
              },
              scopedSlots: _vm._u([
                {
                  key: "button-content",
                  fn: function () {
                    return [
                      _c(
                        "b-button",
                        {
                          staticClass: "d-lg-inline d-none",
                          attrs: { variant: "white", size: "sm" },
                        },
                        [
                          _c(
                            "span",
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("global.words.actions")) +
                                  "\n            "
                              ),
                              _c("icon", { attrs: { name: "caret-up" } }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("i", { staticClass: "material-icons d-lg-none" }, [
                        _vm._v("more_vert"),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(" "),
              _vm.isPositiveStatus
                ? _c(
                    "b-dropdown-item",
                    {
                      attrs: { disabled: _vm.disableAccept },
                      on: {
                        click: function ($event) {
                          return _vm.handleClick("accept")
                        },
                      },
                    },
                    [
                      _vm.acceptLoading
                        ? _c("inline-loader", { staticClass: "px-4" })
                        : _c("span", [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.acceptText) +
                                "\n        "
                            ),
                          ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-dropdown-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handleClick("details")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$tc("global.words.detail", 2)) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.isPositiveStatus
                ? _c(
                    "b-dropdown-item",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.handleClick("preview")
                        },
                      },
                    },
                    [
                      _vm.previewLoading
                        ? _c("inline-loader")
                        : _c("span", [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("global.words.preview")) +
                                "\n        "
                            ),
                          ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isPositiveStatus && !_vm.mppDisabled
                ? [
                    _c("notification-popover", {
                      attrs: {
                        title: "Important Messages",
                        triggers: "hover",
                        disabled:
                          !_vm.mppMessagesToUse.length &&
                          _vm.mppIsAvailableForDownload,
                        "custom-class": "mpp-messages",
                        placement: "left",
                        type: "default",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "popoverTarget",
                            fn: function () {
                              return [
                                _vm.mppIsAvailableForDownload
                                  ? _c(
                                      "b-dropdown-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleClick(
                                              "download-mpp"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.$t(
                                                "direct-to-lender.lenderResponse.downloadMPP"
                                              )
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "b-dropdown-item",
                                      {
                                        attrs: {
                                          disabled: _vm.allowSubmitApplication,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleClick(
                                              "generate-mpp"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm.generatingMpp
                                          ? _c("inline-loader")
                                          : _c("span", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "direct-to-lender.lenderResponse.generateMPP"
                                                    )
                                                  ) +
                                                  "\n              "
                                              ),
                                            ]),
                                      ],
                                      1
                                    ),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "popoverContent",
                            fn: function () {
                              return [
                                _c(
                                  "ul",
                                  {
                                    staticClass: "pl-2",
                                    class: {
                                      bullet: _vm.mppMessagesToUse.length > 1,
                                      "mb-0": _vm.mppMessagesToUse.length === 1,
                                    },
                                  },
                                  _vm._l(
                                    _vm.mppMessagesToUse,
                                    function (message) {
                                      return _c("li", { key: message.errMsg }, [
                                        message.error
                                          ? _c(
                                              "span",
                                              [
                                                _c("icon", {
                                                  staticClass:
                                                    "text-danger bold",
                                                  attrs: {
                                                    name: "times-circle",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(message.message) +
                                            "\n              "
                                        ),
                                      ])
                                    }
                                  ),
                                  0
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        3081481693
                      ),
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }